module.exports = __webpack_public_path__ + "media/images/sinoredi-ccf97cc571047bf8b410e16de8080353.png";